import "./Stories.module.css";
import Header from "@/reusable_sections/Header";
import LatestFromTheField from "./sections/LatestFromTheField";
import Newsletter from "./sections/Newsletter";
import Footer from "@/reusable_sections/Footer";
export default function StoriesPage() {
  return <div>
      <Header />
      <LatestFromTheField />
      <Newsletter />
      <Footer />
    </div>;
}